import type { ReactNode } from 'react'

import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { LocalStorageKeys } from '@/consts/localStorage.ts'
import { ChattingPageLoader } from '@/modules/chatting/ui/components/chatting-page-loader'
import { AppRoutes } from '@/utils/constants'

import { useAccount } from '../hooks/useAccounts'

// Prevents all routes from render if user isnt logged in
export const AccountGuard = ({ children }: { children: ReactNode }) => {
  const { isLoggedIn } = useAccount()
  const location = useLocation()

  const isChattingPage = location.pathname.startsWith(
    AppRoutes.Chatting.Base.asUrl(),
  )

  if (isChattingPage && isLoggedIn === undefined) {
    return <ChattingPageLoader />
  }

  // Render spinning loader when account isnt initialized
  if (isLoggedIn === undefined) {
    return null
  }

  const accountPagePaths: string[] = [
    AppRoutes.Auth.Register.asUrl(),
    AppRoutes.Auth.RegisterAfterPayment.asUrl(),
    AppRoutes.Auth.Login.asUrl(),
    AppRoutes.Auth.ApplyPromo.asUrl(),
  ]

  const isAccountPage =
    accountPagePaths.includes(location.pathname) ||
    location.pathname.startsWith(AppRoutes.Auth.ResetPassword.asUrl()) ||
    location.pathname.startsWith(AppRoutes.Auth.ActivateAccount.asUrl())

  if (typeof window !== 'undefined' && !isAccountPage && !isLoggedIn) {
    if (location.pathname !== AppRoutes.Home.asUrl()) {
      sessionStorage.setItem(
        LocalStorageKeys.REDIRECT_AFTER_LOGIN,
        location.pathname,
      )
    }

    return (
      <Navigate
        replace
        to={AppRoutes.Auth.Login.asUrl()}
      />
    )
  }

  return children || <Outlet />
}
